export const FLASH_MESSAGE_EVENT = 'sayable:flash-message';

let flashMessageSequence = 0;

const FLASH_MESSAGE_TYPES = new Set(['success', 'error', 'warning', 'info']);

const flashMessage = (type, message, options = {}) => {
  if (typeof window === 'undefined' || message == null || message === '') return;

  const normalizedType = FLASH_MESSAGE_TYPES.has(type) ? type : 'success';
  const defaultDuration = normalizedType === 'error' ? 6000 : 4500;
  const requestedDuration = Number(options.duration);
  const duration = Number.isFinite(requestedDuration) && requestedDuration > 0
    ? requestedDuration
    : defaultDuration;

  flashMessageSequence += 1;
  window.dispatchEvent(new CustomEvent(FLASH_MESSAGE_EVENT, {
    detail: {
      id: `${Date.now()}-${flashMessageSequence}`,
      type: normalizedType,
      message: String(message),
      duration,
    },
  }));
};

export default flashMessage;
